import type { ResponseTxFees } from "@/hooks/tx-flow/useDepositStart";
import { SupText } from "@repo/core-ui";
import React, { useMemo } from "react";

interface Web3DepositHighFeesWarningProps {
  totalGasCost?: number;
  discountedAmount?: ResponseTxFees;
}

export default function Web3CommonHighFeesWarning({ totalGasCost, discountedAmount }: Web3DepositHighFeesWarningProps) {
  const isHighFees = useMemo(() => {
    const totalFees = (totalGasCost ?? 0) + (discountedAmount?.original_fee_usd ? discountedAmount.original_fee_usd - discountedAmount.discount_usd : 0);
    return totalFees > 20;
  }, [discountedAmount, totalGasCost]);

  return (
    isHighFees && (
      <div className="bg-warning-50 p-4">
        <SupText variant="caption" className="text-warning-900">
          <strong>NOTICE:</strong> The transaction fee is over $20. This is normal for transactions to or from Ethereum. To reduce the cost, transact to or from an L2 or use a
          SuperPool.
        </SupText>
      </div>
    )
  );
}
